import { endOfDay, startOfDay, subDays } from 'date-fns';

import type { EnvType, OrderFilterStatus, SourceType, TaskStatus, TemplatesProductCombinations } from 'api/types';

import { PeriodType } from './period';

export type Filters = {
  env: EnvType[];
  date_from: string;
  date_to: string;
  period?: string;
  orderStatus?: OrderFilterStatus;
  taskStatus?: TaskStatus;
  responseStatus?: string;
  product_type?: string;
  provider?: string;
  products?: TemplatesProductCombinations;
  source?: SourceType | '';

  query?: string;

  page?: number;
  page_size?: number;
  ordering?: string;
  link_exists?: boolean | null;
};

const DEFAULT_PERIOD_DAYS = 30;

export const DEFAULT_PERIOD_CODE = PeriodType.Last30Days;

export const DEFAULT_PAGE_SIZE = 20;

export const defaultFilters: Filters = {
  env: ['sandbox'],
  period: DEFAULT_PERIOD_CODE,
  date_from: subDays(startOfDay(new Date()), DEFAULT_PERIOD_DAYS).toISOString(),
  date_to: endOfDay(new Date()).toISOString(),
  page: 1,
  page_size: DEFAULT_PAGE_SIZE,
};
